import {
  STOCK_REPORT_STOCK_BEGIN,
  STOCK_REPORT_STOCK_DISMISS_ERROR,
  STOCK_REPORT_STOCK_FAILURE,
  STOCK_REPORT_STOCK_SUCCESS
} from './constants'
import axios from 'axios'
import { STOCKS_ENDPOINT } from 'cfgCommon/endpoints'

export function reportStock(args = {}) {
  return async (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: STOCK_REPORT_STOCK_BEGIN,
    });
    try {
        const res = await axios(`${STOCKS_ENDPOINT}/excel?isNewCar=${args.nuevo}&car_lot_id=${args.carLotSelected}&isFactured=${args.factured}`, {
          method: 'GET',
          timeout: 300000, // 5 minutos
        })

        // TODO: maybe generate a helper function
        const link = document.createElement('a');
        link.href = res.data.downloadUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        dispatch({
          type: STOCK_REPORT_STOCK_SUCCESS,
          data: res,
        })

        return res

    } catch (err) {
        dispatch({
          type: STOCK_REPORT_STOCK_FAILURE,
          data: { error: err },
        })

        return Promise.reject(err)
    }
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissReportStockError() {
  return {
    type: STOCK_REPORT_STOCK_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_REPORT_STOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        reportStockPending: true,
        reportStockError: null,
      };

    case STOCK_REPORT_STOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        reportStockPending: false,
        reportStockError: null,
      };

    case STOCK_REPORT_STOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        reportStockPending: false,
        reportStockError: action.data.error,
      };

    case STOCK_REPORT_STOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        reportStockError: null,
      };

    default:
      return state;
  }
}
